import createAsyncGetters from '../config/asyncGetters/createAsyncGetters';
import { MarketingCommunityEvent } from '../airtable/marketing.types';
import { duration } from '../utils/duration';

export const airtableAsyncGetters = createAsyncGetters({
  fetchMarketingEvents: async (
    _: void,
    api,
  ): Promise<MarketingCommunityEvent[]> => {
    const results = await api.airtable.getTable('Marketing');

    if (!results) {
      return [];
    }

    return results.map((x) => {
      let rewards = {};

      try {
        const rwd = JSON.parse(x.Rewards as string);

        // Neither JSON.parse(false) or JSON.parse(1234) throw errors,
        // but JSON.parse(null) returns null, and typeof null === "object",
        // so we must check for that, too.
        if (rwd && typeof rwd === 'object') {
          rewards = rwd;
        }
      } catch (e) {
        // noop
      }

      return {
        id: x.Id,
        date: x.Date,
        rewards,
        duration: duration({ seconds: x.Duration as number }),
      };
    }) as MarketingCommunityEvent[];
  },
});
